import { Component, computed, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PersonNamePipe } from '~/app/pipes/PersonName';
import { Dialog } from '~/app/services/dialog.service';

@Component({
  selector: 'gplus-force-unpair-modal',
  imports: [TranslateModule],
  providers: [PersonNamePipe],
  templateUrl: './force-unpair-modal.component.html',
  styleUrl: './force-unpair-modal.component.scss'
})
export class ForceUnpairModalComponent {
  public dialog = input<Dialog>(null);
  private readonly personNamePipe = inject(PersonNamePipe);

  public patientName = computed(() => this.personNamePipe.transform(this.dialog()?.data?.patient));
}
